import { render, staticRenderFns } from "./bauauftraege.vue?vue&type=template&id=732b9ba4&"
import script from "./bauauftraege.vue?vue&type=script&lang=js&"
export * from "./bauauftraege.vue?vue&type=script&lang=js&"
import style0 from "./bauauftraege.vue?vue&type=style&index=0&id=732b9ba4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports